"use strict";
function Ajaxinate(e) {
  var t = e || {};
  this.settings = Object.assign(
    {
      method: "scroll",
      container: "#AjaxinateContainer",
      pagination: "#AjaxinatePagination",
      offset: 0,
      loadingText: "Loading",
      callback: null,
    },
    t
  );
  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.preventMultipleClicks = this.preventMultipleClicks.bind(this);
  this.removeClickListener = this.removeClickListener.bind(this);
  this.removeScrollListener = this.removeScrollListener.bind(this);
  this.removePaginationElement = this.removePaginationElement.bind(this);
  this.destroy = this.destroy.bind(this);
  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);
  this.initialize();
}

Ajaxinate.prototype.initialize = function () {
  if (this.containerElement) {
    if (this.settings.method === "click") {
      this.addClickListener();
    } else if (this.settings.method === "scroll") {
      this.addScrollListeners();
    } else {
      console.error("Unbekannte Methode für Ajaxinate: " + this.settings.method);
    }
  }
};

Ajaxinate.prototype.addScrollListeners = function () {
  if (this.paginationElement) {
    document.addEventListener("scroll", this.checkIfPaginationInView);
    window.addEventListener("resize", this.checkIfPaginationInView);
    window.addEventListener("orientationchange", this.checkIfPaginationInView);
  }
};

Ajaxinate.prototype.addClickListener = function () {
  if (this.paginationElement) {
    this.nextPageLinkElement = this.paginationElement.querySelector("a");
    this.clickActive = true;
    if (
      this.nextPageLinkElement !== undefined &&
      this.nextPageLinkElement !== null
    ) {
      this.nextPageLinkElement.addEventListener(
        "click",
        this.preventMultipleClicks
      );
    }
  }
};

Ajaxinate.prototype.preventMultipleClicks = function (e) {
  e.preventDefault();
  if (this.clickActive) {
    this.nextPageLinkElement.innerText = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  }
};

Ajaxinate.prototype.checkIfPaginationInView = function () {
  var e =
      this.paginationElement.getBoundingClientRect().top -
      this.settings.offset,
    t =
      this.paginationElement.getBoundingClientRect().bottom +
      this.settings.offset;
  if (e <= window.innerHeight && t >= 0) {
    this.nextPageLinkElement = this.paginationElement.querySelector("a");
    this.removeScrollListener();
    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.innerText = this.settings.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.loadMore();
    }
  }
};

Ajaxinate.prototype.loadMore = function () {
  this.request = new XMLHttpRequest();
  this.request.onreadystatechange = function () {
    if (
      this.request.responseXML &&
      !(this.request.readyState !== 4) &&
      !(this.request.status !== 200)
    ) {
      var e = this.request.responseXML.querySelectorAll(
          this.settings.container
        )[0],
        t = this.request.responseXML.querySelectorAll(
          this.settings.pagination
        )[0];
      this.containerElement.insertAdjacentHTML("beforeend", e.innerHTML);
      if (t === undefined) {
        this.removePaginationElement();
      } else {
        this.paginationElement.innerHTML = t.innerHTML;
        if (
          this.settings.callback &&
          typeof this.settings.callback === "function"
        ) {
          this.settings.callback(this.request.responseXML);
        }
        this.initialize();
      }
    }
  }.bind(this);
  this.request.open("GET", this.nextPageUrl);
  this.request.responseType = "document";
  this.request.send();
};

Ajaxinate.prototype.removeClickListener = function () {
  this.nextPageLinkElement.removeEventListener(
    "click",
    this.preventMultipleClicks
  );
};

Ajaxinate.prototype.removePaginationElement = function () {
  this.paginationElement.innerHTML = "";
  this.destroy();
};

Ajaxinate.prototype.removeScrollListener = function () {
  document.removeEventListener("scroll", this.checkIfPaginationInView);
  window.removeEventListener("resize", this.checkIfPaginationInView);
  window.removeEventListener("orientationchange", this.checkIfPaginationInView);
};

Ajaxinate.prototype.destroy = function () {
  {
    click: this.removeClickListener;
    scroll: this.removeScrollListener;
  }[this.settings.method]();
  return this;
};

window.Ajaxinate = Ajaxinate;
